export default __webpack_public_path__ + "static/media/Rebecca_Marshall_AHV_In_Moms_We_Trust.db72bc5e.jpg";